import {StoreConstants} from '../constants/store.constants';

export const dbActions = {
  dbReady: (dbReady: boolean) => ({
    group: StoreConstants.StoreGroups.Db,
    type: StoreConstants.Db.DB_READY,
    dbReady
  }),
  dataReady: (dataReady: boolean) => ({
    group: StoreConstants.StoreGroups.Db,
    type: StoreConstants.Db.DATA_READY,
    dataReady
  }),
  feed: (feed: any) => ({
    group: StoreConstants.StoreGroups.Db,
    type: StoreConstants.Db.FEED,
    feed
  }),
  sync: (sync: any) => ({
    group: StoreConstants.StoreGroups.Db,
    type: StoreConstants.Db.SYNC,
    sync
  }),
};
